export default "assets/images/icons/phone-ac2084f7.svg";